import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Separator } from "@/components/ui/separator";
import useBrands from "@/pages/account-settings/organizationSetupTab/useBrands";
import { ChevronsUpDown } from "lucide-react";

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setBrand } from "@/store/common";
import { useRouter } from "next/router";
import { Badge } from "@/components/ui/badge";

export default function WorkspaceSwitch() {
  const dispatch = useDispatch();
  const router = useRouter();

  const selectedBrand = useSelector((state) => state?.common?.brand);

  const { brands, isLoading: isBrandIsLoading } = useBrands();

  useEffect(() => {
    if (!selectedBrand?.label) {
      if (!isBrandIsLoading && brands?.length > 0) {
        const defaultBrand = brands[0];
        dispatch(setBrand(defaultBrand));
        if (typeof window !== "undefined") {
          localStorage.setItem("selectedBrand", JSON.stringify(defaultBrand));
        }
      }
    }
  }, [brands, isBrandIsLoading, selectedBrand, dispatch]);

    const handleBrandChange = (item) => {
      dispatch(setBrand(item));
      if (typeof window !== "undefined") {
        localStorage.setItem("selectedBrand", JSON.stringify(item));
      }
    };

  return (
    <>
      <DropdownMenu className="cursor-pointer ">
        <DropdownMenuTrigger asChild >
          <div className="flex  my-4  items-center cursor-pointer">
            <div className="">
               
              <p className="text-[1.6rem]  leading-[2rem] text-left "> {/* text-[#344054] */}
               {selectedBrand?.label || "Select a workspace"}
              </p>
              <span className="fs-12 text-sidebar-foreground/70 font-[500] text-left block">
                {" "}
                Workspace
              </span>
            </div>

            <ChevronsUpDown className="ml-auto size-8 text-sidebar-foreground/70" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          // side={"right"}
          className="min-w-[28rem] dark:border-input"
          align="start"
        >
            {
                brands?.map((item, index) => (
          <DropdownMenuItem 
          onSelect={() => handleBrandChange(item)}
          key={item.label + index}
          className={`${selectedBrand?.label === item?.label ? "bg-sidebar" : ""} px-4  py-4 flex justify-between items-center cursor-pointer text-[1.6rem] text-sidebar-foreground  leading-[2rem] text-left `}> {/* text-[#344054] */}
            
            {item?.label}
            {/* <p
                        style={{
                          // color: getBrandTypesByTitle(item?.type)?.color,
                          padding: ".2rem .5rem",
                          // background: getBrandTypesByTitle(item?.type)
                          //   ?.bg_color,
                          borderRadius: "1.6rem",
                          fontSize: "1rem",

                        }}
                        className="border"
                      >
                        {item?.type}
                      </p> */}
                      <Badge 
                      variant={`${item?.type == "service" ? "secondary" : "outline"}`}
                      className={'text-[1.4rem] rounded-xl'}
                      >
                        {item?.type}
                      </Badge>
                      
          </DropdownMenuItem>

                ))
            }

         
          <Separator />
          <DropdownMenuItem 
          onSelect={() => router.push('/account-settings/organization-setup') }
          
          className="px-4 py-4 cursor-pointer text-[1.6rem]  leading-[2rem] text-left text-sidebar-foreground/70 "> {/* text-[#344054] */}
            Add Product / Service
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
